import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentTypesSelected = createSelector(
  [
    (store: RootState) => store.massNotification.selectedDocumentTypes,
  ],
  (selectedDocumentTypes) => {

    const orderedList = [...selectedDocumentTypes].sort((a, b) => {
      if (a.name && b.name && a.name < b.name) {
        return -1;
      }
      if (a.name && b.name && a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return orderedList;
  }
);

